module.exports = __webpack_public_path__ + "static/media/calendar_month.35720b62.svg";